import { useEffect, useState } from "react";
import axios from 'axios';
import CrearCuestionario from "../actividades/CrearCuestionario";
import CrearCuestionarioIA from "../IA/CrearCuestionarioIA";
import '../IA/css/ia.css';

import CONFIG from '../../config';
import { useNavigate } from "react-router-dom";

const URL_CUESTIONARIO = `${CONFIG.API_URL}/operarCuestionario.php`;

function Cuestionarios({idMC, rol}) {
    const loggeduserId = localStorage.getItem('loggedUserId');
    const [formularios, setFormularios] = useState([]);
    const [cuestionario, setCuestionario] = useState([{"id":0,"titulo":"","descripcion":"","preguntas":{ pregunta_texto: '', pregunta_tipo: 'text', opciones: [''], correctas: [] }}]);
    const [verNuevoCuestionario, setVerNuevoCuestionario] = useState(false);
    const [verNuevoCuestionarioIA, setVerNuevoCuestionarioIA] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        buscaCuestionarios();            
    }, []);

    const buscaCuestionarios = async () => {
        const response = await axios.get(`${URL_CUESTIONARIO}?user_id=${loggeduserId}&curso_id=${idMC}&rol=${rol}`);
        if(response.data.success){
            setFormularios(response.data.data);
        } else {
            setFormularios([]);
        }
    } 

    const buscaCuestionario = (formId) => {
        const fetchForm = async () => {
            const response = await axios.get(`${URL_CUESTIONARIO}?form_id=${formId}`);
            if(!response.data.error){   
                setCuestionario(response.data.data);
                setVerNuevoCuestionario(true);
            } else {
                setCuestionario([{"id":0,"titulo":"","descripcion":"","preguntas":{ pregunta_texto: '', pregunta_tipo: 'text', opciones: [''], correctas: [] }}]);
            }
        };
        fetchForm();
    }

    const eliminarCuestionario = async (formId) => {
        if(window.confirm('¿Está seguro de eliminar el cuestionario?')){
            const response = await axios.delete(URL_CUESTIONARIO, { data: { modo: 'eliminarCuestionario', idCuestionario: formId } });
            if(response.data.success){
                alert('Cuestionario eliminado');    
                buscaCuestionarios();
            } else {
                alert('Error al eliminar cuestionario');
            }
        }
    };

    return (    
        <div className="container-fluid px-1 py-2">
            {(!verNuevoCuestionario && !verNuevoCuestionarioIA) ? (
                <>
                    {/* Encabezado y botones de acción */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 pb-2 border-bottom">
                        <h4 className="fw-bold mb-2 mb-sm-0 text-dark">
                            <i className="fa-solid fa-clipboard-question text-primary me-2"></i>
                            Cuestionarios del Curso
                        </h4>
                        
                        {(rol == 6 || rol == 5) && (
                            <div className="d-flex gap-2">
                                <button 
                                    type="button" 
                                    className="btn btn-sm btn-dark d-flex align-items-center shadow-sm" 
                                    onClick={() => { setVerNuevoCuestionario(true); setVerNuevoCuestionarioIA(false); }}
                                    title="Crear Cuestionario Manual"
                                >
                                    <i className="fa-regular fa-square-plus me-1"></i> Crear Manual
                                </button>
                                {rol == 6 && (
                                    <button 
                                        type="button" 
                                        className="btn btn-sm btn-primary d-flex align-items-center shadow-sm bg-gradient" 
                                        onClick={() => { setVerNuevoCuestionario(false); setVerNuevoCuestionarioIA(true); }}
                                        title="Generar Cuestionario con Inteligencia Artificial"
                                    >
                                        <i className="fa-solid fa-wand-magic-sparkles me-1"></i> Crear con IA
                                    </button>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Grilla responsiva de tarjetas */}
                    <div className="row g-3">
                        {formularios.length === 0 ? (
                            <div className="col-12 text-center py-5">
                                <i className="fa-regular fa-folder-open display-4 text-muted opacity-50 mb-3 d-block"></i>
                                <p className="text-secondary mb-0">No hay cuestionarios registrados en este curso.</p>
                            </div>
                        ) : (
                            formularios.map((c, index) => (
                                <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
                                    <div className="card h-100 shadow-sm border custom-card-hover bg-white overflow-hidden">
                                        
                                        {/* Header de la tarjeta */}
                                        <div className="card-header bg-light border-0 py-2 px-3 d-flex justify-content-between align-items-center">
                                            <span className={`badge ${c.cantidad_respuestas > 0 ? 'bg-success-subtle text-success border border-success-subtle' : 'bg-secondary-subtle text-secondary border border-secondary-subtle'}`}>
                                                <i className="fa-regular fa-comments me-1"></i>
                                                {c.cantidad_respuestas == 0 ? '0 respuestas' : `${c.cantidad_respuestas} ${c.cantidad_respuestas > 1 ? 'respuestas' : 'respuesta'}`}
                                            </span>
                                            {c.creado_el && (
                                                <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                                    {c.creado_el}
                                                </small>
                                            )}
                                        </div>

                                        {/* Imagen compacta */}
                                        <div style={{ height: '95px', overflow: 'hidden', backgroundColor: '#f1f5f9' }}>
                                            <img 
                                                src="https://img.freepik.com/vector-gratis/ilustracion-lista-verificacion-moderna_79603-146.jpg?w=740" 
                                                className="w-100 h-100" 
                                                style={{ objectFit: 'cover', objectPosition: 'top' }}
                                                alt="Ilustración Cuestionario" 
                                            />
                                        </div>

                                        {/* Cuerpo */}
                                        <div className="card-body p-3 d-flex flex-column justify-content-between">
                                            <h6 className="card-title fw-bold text-dark text-truncate mb-3" title={c.titulo}>
                                                {c.titulo}
                                            </h6>

                                            {/* Acciones */}
                                            <div className="d-flex justify-content-center gap-1 pt-2 border-top">
                                                <button  
                                                    type='button' 
                                                    className="btn btn-outline-success btn-sm px-2 py-1" 
                                                    title="Ver Cuestionario"
                                                    onClick={() => navigate(`/cuestionario/${c.id}`)}
                                                >
                                                    <i className="fa-solid fa-eye me-1"></i> Ver
                                                </button>
                                                
                                                {(rol == 6 || rol == 5) && (c.creado_por == loggeduserId) && (
                                                    <>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-outline-warning btn-sm px-2 py-1" 
                                                            title="Editar Cuestionario"
                                                            onClick={() => buscaCuestionario(c.id)}
                                                        >
                                                            <i className="fa-regular fa-pen-to-square"></i>
                                                        </button>
                                                        <button  
                                                            type='button' 
                                                            className="btn btn-outline-danger btn-sm px-2 py-1" 
                                                            title="Eliminar Cuestionario"
                                                            onClick={() => eliminarCuestionario(c.id)}
                                                        >
                                                            <i className="fa-regular fa-trash-can"></i>
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        {/* Pie de tarjeta (Promedio) */}
                                        {c.porcentaje_promedio_correctas != null && (
                                            <div className="card-footer bg-light border-top text-center py-1 px-2 small text-muted">
                                                <i className="fa-solid fa-chart-line text-success me-1"></i>
                                                Promedio: <strong>{c.porcentaje_promedio_correctas}%</strong>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </>
            ) : (
                <>
                    {verNuevoCuestionario && <CrearCuestionario cuestionario={cuestionario} setVerNuevoCuestionario={setVerNuevoCuestionario} buscaCuestionarios={buscaCuestionarios} idMC={idMC}/>}
                    {verNuevoCuestionarioIA && <CrearCuestionarioIA setVerNuevoCuestionarioIA={setVerNuevoCuestionarioIA} buscaCuestionarios={buscaCuestionarios} buscaCuestionario={buscaCuestionarios} idMC={idMC} />}
                </>
            )}
        </div>
    );
}

export default Cuestionarios;